.root {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.step {
  align-items: center;
  color: var(--color-foreground, #18181b);
  display: flex;
  font-size: 13px;
  gap: 8px;
}

.step-icon {
  flex-shrink: 0;
}

.step-is-success .step-icon {
  color: var(--color-success, #22c55e);
}

// A per-step error is recoverable (the loop retries), so it renders muted —
// not the alarming danger red reserved for a terminal run failure.
.step-is-error {
  color: var(--color-muted-foreground, #71717a);
}

.step-is-error .step-icon {
  color: var(--color-muted-foreground, #71717a);
}

.spinner {
  animation: root-spin 0.8s linear infinite;
  color: var(--color-muted-foreground, #71717a);
  flex-shrink: 0;
}

.final {
  border-top: 1px solid var(--color-border, #e4e4e7);
  margin-top: 4px;
  padding-top: 6px;
}

.final-is-budget {
  color: var(--color-danger, #ef4444);
}

// "Keep going" control under a budget-stopped final (P4.1).
.keep-going {
  display: flex;
  justify-content: flex-start;
  margin-top: 4px;
}

@keyframes root-spin {
  to {
    transform: rotate(360deg);
  }
}
